import type { DealBookDeal } from '@/services/dealBookImport'

/**
 * Does this row need a look before the book is committed? A deal that is not
 * imported (rejected or skipped), or one to be created with a datapoint the file
 * does not state or with a warning. A deal already in Helios is never changed,
 * so nothing on its row is a problem for this import.
 */
export function isProblemRow(deal: DealBookDeal): boolean {
  if (deal.action === 'reject' || deal.action === 'skip') return true
  if (deal.action !== 'create') return false
  return deal.reasons.length > 0 || deal.warnings.length > 0 || (deal.gaps ?? []).length > 0
}
